import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CommonFormattingModule, CommonTranslationModule, CommonUIModule } from '@sdbn/common';
import { EquipmentLogComponent } from './component/equipment-log.component';

@NgModule({
  imports: [
    CommonModule,
    CommonTranslationModule,
    CommonFormattingModule,
    CommonUIModule
],
  declarations: [EquipmentLogComponent],
  exports: [EquipmentLogComponent]
})
export class EquipmentLogModule { }
